document.addEventListener('DOMContentLoaded', function() {
  const recentlyViewedSection = document.querySelector('.recently-viewed-products');
  const recentlyViewedContainer = document.getElementById('recently-viewed-container');
  

  // Get settings from data attributes
  const maxProductsToTrack = recentlyViewedSection.getAttribute('data-max-products-to-track');
  const productsToShowDesktop = recentlyViewedSection.getAttribute('data-products-to-show-desktop');
  const productsToShowMobile = recentlyViewedSection.getAttribute('data-products-to-show-mobile');
  console.log("desktop:", productsToShowDesktop);
  console.log("mobile:", productsToShowMobile);

  // Get the current product handle from the URL
  const currentProductHandle = window.location.pathname.split('/').pop();
  console.log('Current Product Handle:', currentProductHandle);

  // Get the recently viewed handles from localStorage
  let recentlyViewedHandles = JSON.parse(localStorage.getItem('recentlyViewedHandles')) || [];
  console.log('Recently Viewed Handles (Before):', recentlyViewedHandles);

  // Add the current product handle to the recently viewed handles
  if (!recentlyViewedHandles.includes(currentProductHandle)) {
    recentlyViewedHandles.unshift(currentProductHandle);
    if (recentlyViewedHandles.length > maxProductsToTrack) {
      recentlyViewedHandles.pop();
    }
    localStorage.setItem('recentlyViewedHandles', JSON.stringify(recentlyViewedHandles));
  }
  console.log('Recently Viewed Handles (After):', recentlyViewedHandles);

  // Filter out the current product handle from the recently viewed handles
  recentlyViewedHandles = recentlyViewedHandles.filter(handle => handle != currentProductHandle);

  // Hide the recently viewed section if there are no other products
  if (recentlyViewedHandles.length === 0) {
    recentlyViewedSection.style.display = 'none';
    return;
  }

  // Set the grid template columns and wows based on the number of products to show
  function setGridTemplateColumns(){
    if (window.innerWidth <= 600) {
      recentlyViewedContainer.style.gridTemplateColumns = `repeat(2, minmax(0, 1fr))`;
      recentlyViewedContainer.style.gridAutoRows = 'auto';
    } else {
      recentlyViewedContainer.style.gridTemplateColumns = `repeat(${productsToShowDesktop}, minmax(0, 1fr))`;
      recentlyViewedContainer.style.gridAutoRows = '1fr';
    }
  }
  
  // Fetch product details using AJAX
  function fetchProduct(handle) {
    return fetch(`/products/${handle}.js`)
      .then(response => response.json())
      .then(product => {
        console.log('Fetched Product:', product);
        const cheapestVariant = product.variants.reduce((cheapest, variant) => {
          return variant.price < cheapest.price ? variant : cheapest;
        }, product.variants[0]);

        return {
          id: product.id,
          url: `/products/${handle}`,
          featured_image: product.featured_image,
          title: product.title,
          price: cheapestVariant.price,
          compare_at_price: cheapestVariant.compare_at_price
        };
      });
  }

  // Helper function to format price with Indian comma seperators
  function formatPrice(price) {
    return price.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  // Render recently viewed products
  function renderRecentlyViewed(products) {
    recentlyViewedContainer.innerHTML = '';
    setGridTemplateColumns();
    products.slice(0, window.innerWidth <= 600 ? productsToShowMobile : productsToShowDesktop).forEach(product => {
      const productElement = document.createElement('div');
      productElement.className = 'product';
      productElement.innerHTML = `
        <a href="${product.url}">
          <img src="${product.featured_image}" alt="${product.title}">
          <p class="title">${product.title}</p>
          <div class="prices-container">
            <span class="price">Rs. ${formatPrice(product.price / 100)}</span>
            ${product.compare_at_price ? `<span class="compare-at-price">Rs. ${formatPrice(product.compare_at_price / 100)}</span>` : ''}
            ${product.compare_at_price ? `<span class="sale">Sale</span>` : ''}
          </div>
        </a>
      `;
      recentlyViewedContainer.appendChild(productElement);
    });
  } 

  // Fetch details for all recently viewed products
  Promise.all(recentlyViewedHandles.map(handle => fetchProduct(handle)))
    .then(products => {
      console.log('Recently Viewed Products:', products);
      renderRecentlyViewed(products);
    });

  // Adjust grid columns on windows resize
  window.addEventListener('resize', setGridTemplateColumns);
});